import { isGDPRCountry } from '@wework/www-form-utils';
import { updatePhoneNumbersWithGeoData, geoData } from './geo';
import { initLocationSearch } from './location_search/location_search';
import { trackInteraction } from './analytics';
import { listenForFooterInteractionEvents } from './footer';
import { addTrackPhoneNumberClickEvents } from './phone_analytics';

const COUNTRY_CODE_RUSSIA = 'RU';

function showCookieBanner(cookieTextId, cookieName) {
  const cookieWrapper = document.getElementById('cookie-wrapper');
  cookieWrapper.style.display = 'block';

  const cookieText = document.getElementById(cookieTextId);
  cookieText.style.display = 'block';

  document.getElementById('svg-consent').addEventListener('click', () => {
    try {
      if (window.localStorage) {
        window.localStorage.setItem(cookieName, 'true');
      }
    } catch (error) {
      // no-op Safari SecurityError
    }
    cookieWrapper.style.display = 'none';
  });
}

export async function setupPhoneNumbersOnPage() {
  const { countryCode } = await geoData;
  updatePhoneNumbersWithGeoData(countryCode);
  addTrackPhoneNumberClickEvents();
}

export function setUpMobileMenuButtons() {
  const mobileMenuOpenBtn = document.getElementById('mobile-menu-open');
  mobileMenuOpenBtn.addEventListener('click', () => {
    document.body.classList.add('mobile-menu-open');
    document.body.classList.add('js-lock-scroll');
    trackInteraction({
      label: 'Mobile Menu',
      is_open: true
    });
  });

  const mobileMenuCloseBtn = document.getElementById('mobile-menu-close');
  mobileMenuCloseBtn.addEventListener('click', () => {
    document.body.classList.remove('mobile-menu-open');
    document.body.classList.remove('js-lock-scroll');
  });
}

export async function setUpGeoDataStuffAndListenForFooterInteractionsAndInitLocationSearch() {
  let isCookieConsentTrue;
  geoData.then(geo => {
    const countryCodeUpperCase = geo.countryCode.toUpperCase();
    const isCountryRussia = countryCodeUpperCase === COUNTRY_CODE_RUSSIA;
    const isCountryRegulatedByGDPR = isGDPRCountry(countryCodeUpperCase);
    const cookieName = isCountryRussia ? 'russia_cookie_consent' : 'cookie_consent';

    try {
      isCookieConsentTrue = JSON.parse(window.localStorage ? window.localStorage.getItem(cookieName) : null);
    } catch (error) {
      // no-op Safari SecurityError
      // TODO make this catch more specific so it doesn't swallow other exceptions.
    }
    if (countryCodeUpperCase !== 'US') {
      document.getElementById('chat-section').style.display = 'none';
    }

    if (isCountryRegulatedByGDPR) {
      if (!isCookieConsentTrue) {
        showCookieBanner(isCountryRussia ? 'cookie-russia-text' : 'cookie-eu-text', cookieName);
      }

      Array.from(document.querySelectorAll('.gdpr')).forEach(el => {
        el.style.display = 'block'; // eslint-disable-line no-param-reassign
      });
    } else {
      Array.from(document.querySelectorAll('.gdpr-checkbox')).forEach(el => {
        el.checked = true; // eslint-disable-line no-param-reassign
      });
    }
  });

  listenForFooterInteractionEvents(document);

  await initLocationSearch(window);
}

export function waitForGTMheapIdToBeSet() {
  global.addEventListener('load', () => {
    global.analytics.page({ heapUserId: global.GTMheapId && global.GTMheapId.userId });
  });
}
